import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProjectsContainerView } from "src/components/views/erp/project/ProjectsContainerView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/project/projects")({
	staticData: { title: i18n.t("projects"), legacyViewKey: "projectsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <ProjectsContainerView isActive={isActive} />;
}
